import { mapActions, mapGetters, mapState } from 'vuex';
import domainMixin from '../../../mixins/domain';

export default {
  mixins: [domainMixin],
  data() {
    return {
      ruleForm: {
        email: '',
        password: '',
      },
      rules: {
        email: [
          { required: true, message: 'Електрона пошта є обов\'язковою' },
        ],
        password: [
          { required: true, min: 6, message: 'Довжина паролю повина бути від 3 до 8 символів', trigger: 'blur' }
        ],
      }
    };
  },
  computed: {
    ...mapState([
      'loading',
      'isLoggedIn'
    ]),
    ...mapGetters([
      'isAdmin',
      'isManager'
    ]),
  },
  methods: {
    ...mapActions([
      'login'
    ]),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {         
          this.login(this.ruleForm).then(() => {
            if (this.isAdmin) {
              this.$router.push('/users');
            } else if(this.isManager && !this.isTmgaz){
              this.$router.push('/applications');
            } else if(this.isManager && this.isTmgaz){
              this.$router.push('/network-join');
            } else {
              this.$router.push('/');
            }
            
          }).catch((error) => {            
            this.$notify.error({
              title: 'Error',
              message: error.response.data
            });
          });
        } else {
          return false;
        }
      });
    }
  },
}